export default function applyMap(map, baseItem, store) {
  // Every field function's `this` is bound to baseItem (the original,
  // unmodified argument) - none of them read back a value another field
  // just computed in the same pass, so results can be assigned directly
  // onto one copy instead of re-spreading the whole object per field.
  // The previous spread-in-reduce was O(fields x totalKeys) - for a
  // Drupal product with 50-100+ own properties and 25-28 map fields,
  // applied twice per product across hundreds of products during SSR
  // catalog load, that showed up as ~1-2s of measured time.
  const result = { ...baseItem }
  Object.keys(map).forEach(fieldName => {
    result[fieldName] = map[fieldName].call(baseItem, store, map)
  })
  return result
}
